import moment from "moment";
import XLSX from 'xlsx';
import arrayToObject from 'vuex-map-fields/src/lib/array-to-object';
/*eslint no-unused-vars: ["error", { "args": "none" }]*/

export const downloadFile = function (filename, contentDataOrUrl, isBlob = true) {
    const fileURL = isBlob ? window.URL.createObjectURL(new Blob([contentDataOrUrl])) : contentDataOrUrl;
    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", filename);
    document.body.appendChild(fileLink);
    fileLink.click();
}

/*
 * Utils vue2-daterange-picker
 * https://github.com/Innologica/vue2-daterange-picker
 */
let today = new Date()
today.setHours(0, 0, 0, 0)

let yesterday = new Date()
yesterday.setDate(today.getDate() - 1)
yesterday.setHours(0, 0, 0, 0);

export const ranges = {
    'Hoy': [today, today],
    'Ayer': [yesterday, yesterday],
    'Mes actual': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)],
    'Año actual': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
    'Mes pasado': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
    'Año Pasado': [new Date(today.getFullYear() - 1, 0, 1), new Date(today.getFullYear() - 1, 11, 31)]
}


export const nextRanges = function () {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0);

    return {
        'Mes actual': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)],
        'Próximo mes': [new Date(today.getFullYear(), today.getMonth() + 1, 1), new Date(today.getFullYear(), today.getMonth() + 2, 0)],
        'Año actual': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        'Próximo Año': [new Date(today.getFullYear() + 1, 0, 1), new Date(today.getFullYear() + 1, 11, 31)],
    };
}

export const locale = {
    format: 'dd/mm/yyyy', //fomart of the dates displayed
    separator: ' - ', //separator between the two ranges
    weekLabel: 'W',
    customRangeLabel: 'Personalizado',
    daysOfWeek: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_'), //array of days - see moment documenations for details
    monthNames: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'), //array of month names - see moment documenations for details
    firstDay: 1 //ISO first day of week - see moment documenations for details
}

export const exportExcel = function (info) {
    let data = XLSX.utils.json_to_sheet(info.data)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, data, info.sheetname)
    XLSX.writeFile(workbook, `${info.filename}.xlsx`)
}

export const getRandomInt = function (min = 0, max = 100000) {
    return Math.floor(Math.random() * (max - min)) + min;
}

export const years = function (startYear = 2020) {
    let years = [];

    const fromDate = moment(startYear + '-01-01');
    const toDate = moment();
    const diff = toDate.diff(fromDate, 'years');

    for (let i = 0; i <= diff; i++) {
        years.push(moment(fromDate).add(i, 'years').format('Y'))
    }

    return years;
}

export const yearsRange = function (start, end) {
    let years = [];

    const fromDate = moment(start + '-01-01');
    const toDate = moment(end + '-01-01');
    const diff = toDate.diff(fromDate, 'years');

    for (let i = 0; i <= diff; i++) {
        years.push(moment(fromDate).add(i, 'years').format('Y'))
    }
    return years;
}

export const periods = [
    {'label': 'Mensual', value: 1},
    {'label': 'Trimestral', value: 3},
    {'label': 'Anual', value: 12}
];

export const months = function () {
    let months = [];
    for (let i = 0; i < 12; i++) {
        const month = moment().month(i).format("MMMM");
        const shortLabel = moment().month(i).format("MMM");
        months.push({label: month.capitalize(), shortLabel: shortLabel.capitalize(), value: i + 1});
    }
    return months;
}

export const quarters = function () {
    let quarters = [];
    quarters.push({label: 'Q1 (Ene-Mar)', longLabel: 'Q1 (Enero-Marzo)', shortLabel: 'Q1', value: 1});
    quarters.push({label: 'Q2 (Abr-Jun)', longLabel: 'Q2 (Abril-Junio)', shortLabel: 'Q2', value: 2});
    quarters.push({label: 'Q3 (Jul-Sep)', longLabel: 'Q3 (Julio-Septiembre)', shortLabel: 'Q3', value: 3});
    quarters.push({label: 'Q4 (Oct-Dic)', longLabel: 'Q4 (Octubre-Diciembre)', shortLabel: 'Q4', value: 4});
    return quarters;
}

export const reportDateHeaders = function (intervalMonths) {
    let headers = [];
    switch (intervalMonths) {
        case 1:
            headers = months().map((m) => m.label = m.shortLabel);
            break;
        case 3:
            headers = quarters().map((m) => m.label);
            break;
        case 12:
            headers = ['Enero-Diciembre'];
            break;
    }

    return headers;
}

export const reportDateHeadersKeys = function (intervalMonths) {
    let headers = [];
    switch (intervalMonths) {
        case 1:
            headers = months().map((m) => {
                return { label: m.shortLabel, key: `M${m.value}`}
            });
            break;
        case 3:
            headers = quarters().map((m) => {
                return {label: m.label, key: `Q${m.value}`}
            });
            break;
        case 12:
            headers = [{label: 'Enero-Diciembre', key: 'Enero-Diciembre'}]
            break;
    }

    return headers;
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

export const getRestockRuleOperations = function (rule) {
    rule.restock = getRestockOperation(rule.restock.data, 'restock')
    rule.resale = getRestockOperation(rule.resale.data, null)
    return rule;
}

export const getRestockOperation = function (data, type = null) {

    let objectArray = Object.entries(data);
    let final = [];

    // if (type === 'restock')
    //     final.push('(stock < stock_target)')

    objectArray.forEach(([key1, value1]) => {
        let operation = value1.operation

        if (value1.children && value1.children.data) {
            let childrenObjectArray = Object.entries(value1.children.data);
            childrenObjectArray.forEach(([key2, value2]) => {
                operation += ' & ' + value2.operation;
            })
        }
        final.push(operation)
    })

    return final;
}

export const isNumber = function (n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}

/**
 * Funcion para mapear arrays dinamicos utilizando vuex-map-fields
 * https://github.com/maoberlehner/vuex-map-fields/issues/24#issuecomment-521175379
 * @param namespace
 * @param fields
 * @param indexField
 * @returns {{}}
 */
export function mapDynamicFields(namespace, fields, indexField) {
    const fieldsObject = Array.isArray(fields) ? arrayToObject(fields) : fields;

    return Object.keys(fieldsObject).reduce((prev, key) => {
        const field = {
            get() {
                // 'this' refer to vue component
                const path = fieldsObject[key].replace('[]', `[${this[indexField]}]`);
                return this.$store.getters[`${namespace}/getField`](path);
            },
            set(value) {
                // 'this' refer to vue component
                const path = fieldsObject[key].replace('[]', `[${this[indexField]}]`);
                this.$store.commit(`${namespace}/updateField`, { path, value });
            },
        };

        prev[key] = field;
        return prev;
    }, {});
}

export function findRouteName(routeName, item) {
    if (item.routeName && item.routeName === routeName) {
        return item;
    }
    let itemsProperty = item.items ? 'items' : 'subItems';
    if (item[itemsProperty] && item[itemsProperty].length) {
        let res;
        item[itemsProperty].find(item => {
            res = findRouteName(routeName, item);
            return res;
        });

        if (res) {
            return res;
        }
    }
}


export function isMobile() {
    if( screen.width <= 760 ) {
        return true;
    }
    else {
        return false;
    }
}